import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import DateInput from "../../inputs/date-input";
import OptionToggler from "../../OptionToggler";

// Extracted from AddGoal.js's `modalState === "bodyWeight"` block - see
// PersonalRecordFields.js's own comment for why (reused inline in
// Periodization's manage-milestone-goals modal, see
// ~/.claude/plans/periodization-add-goal-modal.md Fase 2).
export const BodyweightFields = ({
  t,
  unitsOptions,
  units,
  targetWeight,
  setTargetWeight,
  setTargetUnits,
  targetDate,
  setTargetDate,
}) => (
  <>
    <div className="form-col">
      <label htmlFor="targetReps">
        {t("coaching-portal:addGoal.bodyweight")}
      </label>
      <div className="form-row">
        <input
          type="number"
          name="targetWeight"
          placeholder={t("coaching-portal:addGoal.enterBodyweight")}
          className="question-input"
          value={targetWeight}
          onChange={(e) => {
            const { value } = e.target;

            setTargetWeight(String(value));
          }}
        />
        <div className="metric-toggler">
          <OptionToggler
            name={"units"}
            options={unitsOptions}
            defaultValue={units}
            onSelectFn={(value) => {
              setTargetUnits(value);
            }}
          />
        </div>
      </div>
    </div>
    <div className="form-col">
      <label htmlFor="targetDate">
        {t("coaching-portal:addGoal.targetDate")}
      </label>

      <DateInput
        name="targetDate"
        placeholder={t("coaching-portal:addGoal.targetDatePlaceholder")}
        value={targetDate}
        min={moment().toDate()}
        onChange={(date) => setTargetDate(date)}
      />
    </div>
  </>
);

BodyweightFields.propTypes = {
  t: PropTypes.func.isRequired,
  unitsOptions: PropTypes.array.isRequired,
  units: PropTypes.string,
  targetWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setTargetWeight: PropTypes.func.isRequired,
  setTargetUnits: PropTypes.func.isRequired,
  targetDate: PropTypes.instanceOf(Date),
  setTargetDate: PropTypes.func.isRequired,
};
